export default __webpack_public_path__ + "static/media/01.483321c0.jpg";